import './authorized.style.sass';
import template from './authorized.tpl.pug';

export default {
    selector: 'dbAAuthorized',
    template: template()
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/authorized.cmpt.js